import { Component, ViewChild, ElementRef } from '@angular/core';
import { Platform, ToastController, NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController, App  } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Geolocation } from '@ionic-native/geolocation';
import { Storage } from '@ionic/storage';
import { AppVersion } from '@ionic-native/app-version'

import { PreloginPage } from '../prelogin/prelogin';

import { Business } from '../../models/business';
import { BusinessManagerHandler } from '../../providers/business-manager-handler';

import { Camera, CameraOptions } from '@ionic-native/camera';

import { Globals } from '../../providers/globals';

declare var $: any;

@Component({
  selector: 'page-business-detail',
  templateUrl: 'business-detail.html'
})
export class BusinessDetailPage {
	@ViewChild('fileInput') fileInput;

	masks: any;
 
    phoneNumber: any = "";

	business: Business;
	private businessManagerForm : FormGroup;
	loader: any;
	public imageSrc: string;
	filePath: any;
	isLoading: boolean = false;
	imageChanging: boolean = false;
	isGettingLocation: boolean = false;
	isSaving: boolean = false;
	isLoggingOut: boolean = false;
	appVersionPrint: any = "1.0";

	constructor(
		platform: Platform, 
		private toastCtrl: ToastController,
		public appVersion: AppVersion,		
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public businessManagerHandler: BusinessManagerHandler,
		public storage: Storage,
		private camera: Camera,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public app: App,
		public actionSheetCtrl: ActionSheetController,
		private geolocation: Geolocation,
		public elementRef: ElementRef
		) {
		this.filePath = this.globals.fileUrl;

	    this.businessManagerForm = this.formBuilder.group({
	    	"Id": [0],
	    	"Email": [''],
		  	"BusinessName":  ['', Validators.required],
		  	"BusinessDescription":  ['', Validators.required],
		  	"BusinessInformation":  [''],
		  	// "Categories": [],
		    // "SubscriptionId": [''],
		    "FullAddress": ['', Validators.required],
		    "Phone": ['', Validators.required],
		    "IsPublished": [''],
		    "GeoLat": ['', Validators.required],
		    "GeoLong": ['', Validators.required],
		    "ImagePath": ['', Validators.required],
	   	});   

	   	this.loadProfile()

		platform.ready().then((readySource) => {
	        if(readySource!="dom"){
				this.appVersion.getVersionNumber().then((version)=> {
		    		this.appVersionPrint = version;
				});	          
	        }
		});	   	

		this.masks = {
            phoneNumber: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        };
	}

	ionViewWillEnter(){		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessDetailManagerPage');
	}

	loadProfile(){
		this.isLoading = true;

		this.businessManagerHandler.getBusinessInfo((result)=>{
		  	
		  	if(result.Id > 0){
		  		this.business = result

		  		this.businessManagerForm.patchValue(
		    			result
		    	)

		    	var catObject = {
		    		"Categories": result.Categories
		    	}

		    	this.businessManagerForm.patchValue(
		    		catObject
		    	) 

		  		this.filePath = this.globals.fileUrl + this.business.ImagePath;
		    	
		  	}

		  	this.isLoading = false;
		})
	}

	onSubmit(){
		this.isSaving = true;

		console.log(this.businessManagerForm.value);

		this.businessManagerHandler.udpateBusiness(this.businessManagerForm.value, (result)=>{
			this.isSaving = false;

			let toast = this.toastCtrl.create({
				message: 'Profile has been updated',
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		})
	}

	presentActionSheet() {
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Choose the source for an image',
	     buttons: [
	       {
	         text: 'Camera',
	         handler: () => {

	           this.getImage(true)
	         }
	       },
	       {
	         text: 'Image Gallery',
	         handler: () => {

	           this.getImage(false)
	         }
	       },
	       {
	         text: 'Cancel',
	         role: 'cancel',
	         handler: () => {
	           console.log('Cancel clicked');
	         }
	       }
	     ]
	   });

	   actionSheet.present();
	}

	logOut(){
		if(this.isLoggingOut) return;
		
		this.isLoggingOut = true

		let confirm = this.alertCtrl.create({
		  title: 'Logout?',
		  message: 'Are you sure you want to log out?',
		  buttons: [
		    {
		      text: 'No',
		      handler: () => {
		        console.log('Disagree clicked');

		        this.isLoggingOut = false
		      }
		    },
		    {
		      text: 'Yes',
		      handler: () => {
		        this.storage.set('loginData', null)

		        this.isLoggingOut = false

		        this.app.getRootNav().setRoot(PreloginPage);		        
		      }  
		    }
		  ]
		});

		confirm.present();
	}	
	
	getCoordinates(){ 

		this.isGettingLocation = true

		this.geolocation.getCurrentPosition().then((resp) => {

			var geoObject = {
	    		"GeoLat": resp.coords.latitude,
	    		"GeoLong": resp.coords.longitude
	    	}

	    	this.businessManagerForm.patchValue(
		    		geoObject
		    ) 

		    this.isGettingLocation = false

		}).catch((error) => {
			console.log('Error getting location', error);
		});
	}

	private getImage (fromCamera): void {

		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		this.camera.getPicture(options).then((dataUrl) => {
			if(this.filePath != ''){
				

	    		this.businessManagerHandler
	    		.updateBusinessImage({
	    			id: this.business.Id,
	    			imageString: 'data:image/png;base64,' + dataUrl,
	    			cb: (data)=>{
	    				this.imageChanging = false;

	    				console.log("New image path: " + data);

	    				this.business.ImagePath = data;

	    				var imgObject = {
				    		"ImagePath": data
				    	}

				    	console.log(imgObject);

				    	this.businessManagerForm.patchValue(
				    		imgObject
				    	) 

				    	this.filePath = this.globals.fileUrl + this.business.ImagePath;
	    			}
	    		})
			} else {
				 // dataUrl is either a base64 encoded string or a file URI
				 // If it's base64:
				 let base64img = 'data:image/png;base64,' + dataUrl;

				 this.imageSrc = base64img;

				 var imgObject = {
			    		"ImagePath": base64img,
			    }

		    	this.businessManagerForm.patchValue(
		    		imgObject
		    	) 

		    	this.imageChanging = false;
		    }

	    	
			}, (err) => {
			 // Handle error
			 alert('Unable to take photo');

			 this.imageChanging = false;
			});
	}

	getPicture() {
	    if (Camera['installed']()) {

	      this.presentActionSheet();
	    
	    } else {
	      
	      this.fileInput.nativeElement.click();
	    
	    }
	}

	processWebImage(event) {
	    let reader = new FileReader();
	    reader.onload = (readerEvent) => {

		    let imageData = (readerEvent.target as any).result;

		    // if(!this.filePath){

		    // 	this.imageSrc = imageData;

		    // 	var imgObject = {
			   //  	"ImagePath": imageData,
			   //  }

		    // 	this.businessManagerForm.patchValue(
		    // 		imgObject
		    // 	) 

		    // }

		    this.imageChanging = true;

			this.businessManagerHandler
			.updateBusinessImage({
				id: this.business.Id,
				imageString: imageData,
				cb: (data)=>{ 

					console.log("New image path: " + data);

					this.business.ImagePath = data;

					var imgObject = {
			    		"ImagePath": data
			    	}

			    	console.log(imgObject);

			    	this.businessManagerForm.patchValue(
			    		imgObject
			    	) 

			    	// this.imageSrc = null

			    	this.filePath = this.globals.fileUrl + this.business.ImagePath;

			    	this.imageChanging = false;
				}
			})
	    }; 
 
	    reader.readAsDataURL(event.target.files[0]);
	}

	getProfileImageStyle() {

	    return this.businessManagerForm.controls['ImagePath'].value
	}


}



// WEBPACK FOOTER //
// ./src/pages/business-detail/business-detail.ts